export default __webpack_public_path__ + "static/summer_containers70-0dcc51b30749370da84610042b325709.webp";